import script from "./showFile.vue?vue&type=script&setup=true&lang=js"
export * from "./showFile.vue?vue&type=script&setup=true&lang=js"

import "./showFile.vue?vue&type=style&index=0&id=7fea1727&scoped=true&lang=less"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fea1727"]])

export default __exports__